<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>{{ title }}</ng-container>
  <ng-container body>
    @if (cardDetail()) {
      <app-virtual-card-static
        [cardDetail]="cardDetail()"
        [isCentered]="true"></app-virtual-card-static>
    }
    <ng-content select="[specifyCard]"></ng-content>
    @if (this.cardDetail().type === CardType.Subscription) {
      <p class="text-muted mt-4">
        Would you like to
        {{ isReasonOther() ? 'remove' : 'replace' }}
        the card?
      </p>
    }

    @if (this.cardDetail().type === CardType.Subscription) {
      <div class="row mt-3 gy-3 mt-sm-auto offcanvas-buttons">
        <div class="col-12 col-sm-auto">
          @if (isReasonOther()) {
            <button
              (click)="goToRemoveCard()"
              class="btn btn-outline-dark"
              type="button">
              Remove card
            </button>
          } @else {
            <button
              (click)="goToReplaceCard()"
              class="btn btn-outline-dark ms-3">
              Replace card
            </button>
          }
        </div>
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            (click)="goToCardDetail()"
            class="btn btn-primary">
            Done
          </button>
        </div>
      </div>
    }
  </ng-container>
</app-offcanvas-base>
